// src/components/Modal/ConfirmModal.jsx
import Modal from "react-modal";
import Button from "../Elements/Button";
const ConfirmModal = ({
  isOpen,
  onConfirm,
  onCancel,

  // Content
  title = "Are you sure?",
  message = "Please confirm this action.",
  avatarSrc = null,
  avatarAlt = "Avatar",

  // Buttons
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",

  // Styling overrides
  confirmButtonStyle,
  confirmButtonClassName = "py-3 text-white w-1/2",
  cancelButtonClassName = "border border-card-border py-3 w-1/2",

  // Modal config overrides
  portalClassName = "outline-none",
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      overlayClassName="
        fixed inset-0 bg-black bg-opacity-50 z-50 
        flex items-center justify-center
      "
      className={portalClassName}
      ariaHideApp={false}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-72 sm:w-96">
        {avatarSrc && (
          <div className="flex items-center justify-center">
            <img
              className="w-16 h-16 rounded-full object-cover"
              src={avatarSrc}
              alt={avatarAlt}
              loading="lazy"
            />
          </div>
        )}

        <div className="text-center font-semibold">
          <p className="pt-6 text-base">{title}</p>
          <p className="pb-6 text-sm font-normal text-gray-600">{message}</p>

          <div className="flex justify-center gap-3">
            <Button
              title={confirmLabel}
              type="fill"
              fillColor="primary"
              className={confirmButtonClassName}
              style={confirmButtonStyle}
              onClick={onConfirm}
            />

            <Button
              className={cancelButtonClassName}
              onClick={onCancel}
              title={cancelLabel}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
